<template>
  <div class="v-sidebar-menu" :class="[!isCollapsed ? 'vsm-default' : 'vsm-collapsed']" :style="{'width': sidebarWidth} " @mouseleave="mouseLeave">
    <div style="text-align: center">
      <router-link to="/" exact>
        <div class="m-2" v-show="!isCollapsed" >
          <img src="/static/img/logo-transparent.png" alt="Royal Pag" width="132px">
        </div>
        <div class="m-2" v-show="isCollapsed">
          <img src="/static/img/icon-crown.png" style="width: 50px">
        </div>
      </router-link>
    </div>
    <div class="vsm-list fa-2x" style="padding-left: 10px;" :style="[{'height' : '-webkit-fill-available', 'margin-bottom': '120px'}, {'overflow' : 'hidden auto'}]">
      <template v-for="(item, index) in menu">
         <template v-if="item.header">
           <div v-if="!isCollapsed" :key="index" class="vsm-header">{{item.title}}</div>
         </template>
         <item v-else :key="index" :item="item" :firstItem="true" :isCollapsed="isCollapsed" />
      </template>
    </div>
    <div v-if="isCollapsed" :style="[{'position' : 'absolute'}, {'top' : `${mobileItemPos}px`}, {'left' : '0px'}, {'z-index' : 30}, {'width' : width}]">
      <mobile-item :item="mobileItem" />
      <transition name="slide-animation">
        <div class="vsm-mobile-bg" v-if="mobileItem" :style="[{'position' : 'absolute'}, {'left' : '0px'}, {'right' : '0px'}, {'top' : '0px'}, {'height' : `${mobileItemHeight}px`}]"></div>
      </transition>
      <div class="vsm-dropdown" :style="[{'position' : 'absolute'}, {'top' : `${mobileItemHeight}px`}, {'left' : sidebarWidth}, {'right' : '0px'}, {'max-height' : `calc(100vh - ${mobileItemPos + mobileItemHeight}px)`}, {'overflow-y' : 'auto'}]">
        <transition name="show-animation">
          <div class="vsm-list" v-if="mobileItem && mobileItem.child">
            <sub-item v-for="(subItem, index) in mobileItem.child" :item="subItem" :key="index"/>
          </div>
        </transition>
      </div>
    </div>
    <div v-show="isCollapsed">
      <button class="logout-btn fas fas fa-door-closed" @click="logout"></button>
    </div>
    <div v-show="!isCollapsed" @click="logout">
      <div class="menu-btn-logout-open">
        <button class="vsm-icon fas fa-door-closed"
                style="
                      float: left;
                      height: 30px;
                      line-height: 0px;
                      width: 30px;
                      margin-left: 20px;
                      margin-top: 5px;
                      cursor: pointer;
                      text-align: center;
                      background: #1e1e21;
                      border-radius: 3px;
                      border: none;
                      color: #fff;">
      </button>
        <span class="vsm-title"
              style="
                font-size: 16px;
                padding-top: 4px;
                cursor: pointer;
                width: 100%;">Sair</span>
      </div>
    </div>
    <button class="collapse-btn fas fa-arrows-alt-h" @click="toggleCollapse"></button>
    <template>
      <the-menu>

      </the-menu>
    </template>
  </div>
</template>

<script>
import Item from './Item.vue'
import SubItem from './SubItem.vue'
import MobileItem from './MobileItem.vue'
import TheMenu from './the-menu.vue'
import localforage from 'localforage'
import { mapActions } from 'vuex'
export default {
  name: 'SidebarMenu',
  components: {
    Item,
    TheMenu,
    SubItem,
    MobileItem
  },
  props: {
    menu: {
      type: Array,
      required: true
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '350px'
    },
    widthCollapsed: {
      type: String,
      default: '80px'
    },
    showChild: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sidebarWidth: this.collapsed ? this.widthCollapsed : this.width,
      isCollapsed: this.collapsed,
      mobileItem: null,
      mobileItemPos: 0,
      mobileItemHeight: 0,
      closeTimeout: null
    }
  },
  created () {
    this.$on('mouseEnterItem', (val) => {
      this.mobileItem = val.item
      this.mobileItemPos = val.pos
      this.mobileItemHeight = val.height
    })

    this.$on('clickItem', () => {
      if (this.closeTimeout) clearTimeout(this.closeTimeout)
      this.closeTimeout = setTimeout(() => {
        this.mouseLeave()
      }, 600)
    })
  },
  methods: {
    ...mapActions(['removeToken']),
    mouseLeave () {
      this.mobileItem = null
    },
    toggleCollapse () {
      this.isCollapsed = !this.isCollapsed
      this.sidebarWidth = this.isCollapsed ? this.widthCollapsed : this.width
      this.$emit('collapse', this.isCollapsed)
    },
    logout () {
      localforage.removeItem('token').then(() => {
        this.removeToken({})
        this.$socket.disconnect()
        this.$router.push({ name: 'auth.index' })
      })
    }
  },
  provide () {
    return {
      showChild: this.showChild
    }
  }
}
</script>


<style lang="scss">
@import '../../assets/sass/menu/sidebar_menu.scss';
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?298fd9e0